import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread"; //@ts-check

import pathUtil from '../../../../../../../utils/pathUtil';
/** This file is to be used to anything edm output related */

/**
 * Add data source to output
 * @param {import('./types').DasJob} job The diagram content
 * @param {import('./types').CsvUrl} csvUrl The data source to add to output content
 */

export var addToOutput = function addToOutput(job, csvUrl) {
  var outputTables = job.biUniverseOutput.biUniverse.tables;
  var existingTableNames = outputTables.map(function (table) {
    return table.name;
  }); // insert into output

  outputTables.push({
    id: getNextId(job),
    name: getValidAvailableBIOutputName(pathUtil.getFileCaption(csvUrl.src), existingTableNames, 'Table'),
    dataSource: csvUrl.id,
    dimensions: function () {
      var dimensions = [];

      for (var fieldIndex = 0; fieldIndex < csvUrl.fields.length; fieldIndex++) {
        var field = csvUrl.fields[fieldIndex];
        dimensions.push({
          id: getNextId(job),
          name: getValidAvailableBIOutputName(field.name, outputTables //no 2 dimensions should have the same name even in different tables
          .flatMap(function (table) {
            return table.dimensions;
          }).concat(dimensions).map(function (dimension) {
            return dimension.name;
          }), 'Dimension'),
          value: field.id,
          type: getDimensionType(field.type)
        });
      }

      return dimensions;
    }()
  });
};

var getNextId = function getNextId(job) {
  var lastId = parseInt(job.lastId);
  lastId++;
  job.lastId = lastId.toString();
  return job.lastId;
};

var getDimensionType = function getDimensionType(variantType) {
  switch (variantType) {
    case 'BoolValue':
    case 'ByteValue':
      return 'short';

    case 'DateTimeExValue':
      return 'date';

    case 'DoubleValue':
      return 'double';

    case 'FloatValue':
      return 'float';

    case 'IntegerValue':
    case 'UIntValue':
      return 'int';

    case 'LongValue':
    case 'ULongValue':
      return 'int64';

    case 'ShortValue':
      return 'short';

    case 'StringValue':
      return 'string';

    case 'NullValue':
    case 'ByteArrayValue':
    default:
      return 'string';
  }
};

var getValidAvailableBIOutputName = function getValidAvailableBIOutputName(name, existingNames, emptyName) {
  function isLetter(str) {
    return str.length === 1 && str.match(/[a-zA-Z]/i);
  }

  function getValidBIOutputName(name, emptyName) {
    var validName = name.replace(/[^a-zA-Z0-9-_]/g, '');

    while (validName.length > 0 && !isLetter(validName[0])) {
      validName = validName.substring(1);
    }

    if (validName.length === 0) validName = emptyName;
    return validName;
  }

  name = getValidBIOutputName(name, emptyName);
  var index = 0;
  var result = name;

  while (existingNames.includes(result)) {
    index++;
    result = name + index;
  }

  return result;
};
/**
 * Remove data source from output.
 * @param {import('./types').DasJob} job The diagram content
 * @param {string} dataSourceId The id of the datasource
 */


export var removeFromOutput = function removeFromOutput(job, dataSourceId) {
  var universe = job.biUniverseOutput.biUniverse;
  var table = universe.tables.find(function (item) {
    return item.dataSource === dataSourceId;
  });
  var relationshipItems = universe.relationships.items.filter(function (item) {
    return item.sourceTable !== table.id;
  });
  relationshipItems = relationshipItems.filter(function (item) {
    return item.destinationTable !== table.id;
  });
  universe.relationships.items = relationshipItems;
  universe.tables = universe.tables.filter(function (item) {
    return item.dataSource !== dataSourceId;
  });
};
/**
 * Remove relationship between two data sources.
 * @param {import("./types").DasJob} job The diagram content
 * @param {string} relationshipId The id of the relationship
 */

export var removeRelationship = function removeRelationship(job, relationshipId) {
  var universe = job.biUniverseOutput.biUniverse;
  var relationshipItems = universe.relationships.items.filter(function (relationship) {
    return relationship.id !== relationshipId;
  });
  universe.relationships.items = relationshipItems;
};
/**
 * Update a relationship between two data sources.
 * @param {import("./types").DasJob} job The diagram content
 * @param {any} relationshipValues The id of the relationship
 */

export var updateRelationship = function updateRelationship(job, relationshipValues) {
  var universe = job.biUniverseOutput.biUniverse;

  var newRelationship = _objectSpread({}, relationshipValues);

  if (!relationshipValues.id) {
    newRelationship.id = getNextId(job);
    universe.relationships.items.push(newRelationship);
  } else {
    var relationshipIndex = universe.relationships.items.findIndex(function (relationship) {
      return relationship.id === relationshipValues.id;
    });
    universe.relationships.items.splice(relationshipIndex, 1, newRelationship);
  } // update primary key


  var sourceTable = universe.tables.find(function (table) {
    return table.id === relationshipValues.sourceTable;
  });
  sourceTable.primaryKeyId = relationshipValues.sourceColumn;
};